(function(){
    var s = document.getElementsByTagName("script");
    var d = s[s.length-1].src.substring(0, s[s.length-1].src.lastIndexOf("/")+1);
    for(var i=0; i<arguments.length; i++){
        document.write('<script type="text/javascript" src="'+d+arguments[i]+'"></script>');
    }
})(
    "jquery.js",
    "slick/slick.js",
//    "jquery.easing.min.js",
    "swimg.js",
    "jquery.flexnav.js",
    "opacity-rollover2.1.js",
    "ofi.js",
    "accordion.js",
    "jquery.nice-select.js",
    "jquery.matchHeight-min.js",
    "customize.js"
);


